<!-- 
  评论回复文本框
 -->

<template>
  <div class="comment-box" :class="{'active': open}">
    <textarea
      v-model="textarea"
      ref="textArea"
      class="enter"
      placeholder="输入回复内容..."
      @keyup="mention"
      @focus="openBox">
    </textarea>
    <div class="mention-result" v-show="mentionList.length">
      <ul>
        <li class="first">
          <span class="text">选择你要@的人</span>
        </li>
        <li
          class="me-item"
          v-for="(item, index) in mentionList"
          :class="{actived: Mcurrent === index}"
          @click="selectMention(item)"
          @mouseover="changeCurrent(index)">
          <span class="text">{{item.value}}</span>
        </li>
      </ul>
    </div>
    <div class="btn-group">
      <el-button size="small" type="primary" @click="handleEmit">回 复</el-button>
      <el-button size="small" @click="closeBox">取 消</el-button>
    </div>
  </div>
</template>

<script>
import atSomeone from './at-someone'

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: this.isOpen
    }
  },
  mixins: [atSomeone],
  methods: {
    // 展开
    openBox () {
      this.open = true
    },
    // 收回
    closeBox () {
      this.open = false
    },
    // 提交回复
    handleEmit () {
      this.$emit('reportContent', this.textarea.replace(this.refName, ''), this.refUserId, () => {
        this.textarea = ''
        this.open = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';
  .comment-box {
    padding-bottom: 13px;
    &.active {
      .enter {
        height: 62px;
      }
      .btn-group {
        display: block;
      }
    }
    .enter {
      display: block;
      resize: none;
      box-sizing: border-box;
      background:#ffffff;
      border:1px solid #e5ecf7;
      border-radius:2px;
      padding: 7px;
      font-size: 13px;
      height: 32px;
      width: 100%;
      transition: height 0.5s;
      color: #666;
    }
    .mention-result {
      position: absolute;
      left: 16px;
      top: 78px;
      z-index: 50;
      width: 200px;
      background-color: #fff;
      box-shadow: 0 0 4px 0 rgba(114, 114, 114, 0.5);
      padding: 2px;
      border-radius: 2px;
      overflow: auto;
      font-size: 13px;
      .first {
        padding: 5px 10px;
      }
      .me-item {
        padding: 8px 10px;
        cursor: pointer;
        &:hover, &.actived {
          background-color: #f3f5f7;
          color: @bg-orange;
        }
      }
    }
    .btn-group {
      margin-top: 15px;
      text-align: right;
      display: none;
      .el-button--small {
        padding: 7px 15px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// index.vue?61c1786b